module.exports = __webpack_public_path__ + "img/Topic-covid.2b85c549.svg";